import { render, staticRenderFns } from "./newMaterialArticleDetail.vue?vue&type=template&id=3952fcf9&scoped=true&"
import script from "./newMaterialArticleDetail.vue?vue&type=script&lang=js&"
export * from "./newMaterialArticleDetail.vue?vue&type=script&lang=js&"
import style0 from "./newMaterialArticleDetail.vue?vue&type=style&index=0&id=3952fcf9&lang=less&scoped=true&"
import style1 from "./newMaterialArticleDetail.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3952fcf9",
  null
  
)

component.options.__file = "newMaterialArticleDetail.vue"
export default component.exports